<div class="terms-container">
    <div class="last-updated"><em>Last Updated:</em> April 2026</div>
    <ol class="terms-lists">
        <li class="terms-list">
            <h3 class="list-header-text">Agreement to Terms</h3>
            <p class="list-content">By accessing Capvizon, you agree to these
                Terms of Use and our Privacy Policy.</p>
        </li>

        <li class="terms-list">
            <h3 class="list-header-text">Description of Service</h3>
            <p class="list-content">Capvizon provides a platform for users to
                manually log, share, and
                calculate expenses. We are an <strong
                    class="content-strong-text">information storage and
                    calculation
                    tool only.</strong> We do not facilitate payments, money
                transfers, or
                financial transactions.</p>
        </li>

        <li class="terms-list">
            <h3 class="list-header-text">User Responsibilities</h3>
            <p class="list-content">
                <strong class="sub-header-text">Accuracy:</strong> You are
                responsible for the accuracy of
                the data
                you input.<br>
                <strong class="sub-header-text">Security:</strong> You are
                responsible for safeguarding
                your
                password and account access.</p>
        </li>

        <li class="terms-list">
            <h3 class="list-header-text">Disclaimers & Limitation of
                Liability</h3>
            <p class="list-content">
                <strong class="sub-header-text">"As-Is" Basis:</strong> The
                service
                and all calculations are
                provided "as-is." Capvizon does not guarantee 100% mathematical
                accuracy for complex custom splits.</p>
            <p class="list-content">
                <strong class="sub-header-text">Data Breaches:</strong> To the
                maximum extent permitted by
                applicable law, Capvizon shall not be liable for any indirect,
                incidental, or consequential damages resulting from data
                breaches or
                unauthorized access.</p>
            <p class="list-content"><strong class="sub-header-text">No Financial
                    Advice:</strong> Our
                "Expense Insights" are for
                informational purposes only and do not constitute professional
                financial advice.</p>
            <p class="list-content">
                As a startup, Capvizon provides calculation tools "as-is." We
                are not responsible for financial discrepancies or data breaches
                beyond our reasonable control to the maximum extent permitted by
                the Indian Judicial Act.
            </p>
        </li>

        <li class="terms-list">
            <h3 class="list-header-text">Governing Law</h3>
            <p class="list-content">All legal matters and interpretations of
                these terms shall be governed by and construed in accordance
                with the
                <strong class="content-strong-text">Indian Judicial Act</strong>
                and applicable federal laws of India.</p>
        </li>

        <li class="terms-list">
            <h3 class="list-header-text">Mandatory Dispute Resolution & Notice
                Period</h3>
            <p class="list-content">In the event of any controversy, claim, or
                dispute arising out of or relating to these Terms:</p>
            <p class="list-content">
                <strong class="sub-header-text">Pre-Action
                    Notice:</strong> You agree to first attempt to resolve the
                issue informally by sending a detailed written notice to
                <ccdl-link
                    linkText="Privacy and Terms
                    Team."
                    linkType="default"
                    size="xs"
                    [underlineOnHover]="true"
                    [ishrefLink]="true"
                    linkType="link"
                    [routeLink]="'mailto:privacyandterms@capvizon.com'"></ccdl-link></p>

            <p class="list-content">
                <strong class="sub-header-text">Wait Period:</strong> No legal
                proceedings or formal claims may be commenced
                until 90 days have passed from the date the initial notice email
                was
                sent, allowing both parties an opportunity for amicable
                resolution.
            </p>

            <p class="list-content">
                <strong class="sub-header-text">Jurisdiction:</strong> If a
                resolution is not reached within this
                <strong class="content-strong-text">90-day</strong>
                period, the dispute shall be subject to the exclusive
                jurisdiction
                of the courts located in India.
            </p>
        </li>

        <li class="terms-list">
            <h3 class="list-header-text">Contact Us</h3>
            <p class="list-content">Questions regarding these terms should be
                sent to: <ccdl-link
                    linkText="Privacy and Terms
                    Team."
                    linkType="default"
                    size="xs"
                    [underlineOnHover]="true"
                    [ishrefLink]="true"
                    linkType="link"
                    [routeLink]="'mailto:privacyandterms@capvizon.com'"></ccdl-link>
            </p>
        </li>
        <li class="terms-list">
            <p class="list-content">For complete details: <ccdl-link
                    linkText="Read our full Terms of Use."
                    linkType="default"
                    size="xs"
                    [underlineOnHover]="true"
                    linkType="link"
                    linkTarget="_blank"
                    [routeLink]="'legal/terms-of-use'">
                </ccdl-link></p>
        </li>
    </ol>
</div>